/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Pergi_OkInputs */

const en_tut_pergi_ok = /** @type {(inputs: Tut_Pergi_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The briefing is relabelled as read with its timestamp, and a copy stays in the inbox.`)
};

const id_tut_pergi_ok = /** @type {(inputs: Tut_Pergi_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ringkasan berganti label menjadi sudah dibaca beserta waktunya, dan salinannya tersimpan di Inbox.`)
};

/**
* | output |
* | --- |
* | "The briefing is relabelled as read with its timestamp, and a copy stays in the inbox." |
*
* @param {Tut_Pergi_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_pergi_ok = /** @type {((inputs?: Tut_Pergi_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Pergi_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_pergi_ok(inputs)
	return en_tut_pergi_ok(inputs)
});